/* eslint-disable max-len */
/* eslint-disable security/detect-unsafe-regex */

import React, { useRef } from 'react'
import './Preview.css';
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';
import Loader from '../../../../../components/Loader';
import numberToWords from 'number-to-words';


export default function PreviewPayslip({setIsPreview,tableData, branch_data, handleDownload, loadingDownload}) {
    const closeRef = useRef()

    /**
     * The function formatIndianRupee formats a given amount in Indian Rupees by adding commas for
     * thousands, lakhs, crores, etc.
     * @returns the input amount with commas added according to the Indian numbering system.
     */
    function formatIndianRupee(amount) {
        let numberString = `${parseFloat(amount).toFixed(2)}`;
        // Using regular expression to add commas for Indian numbering system
        return parseFloat(numberString).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    /* The above code is using a custom hook called `useOnClickOutside` to handle a click event outside
    of a specified element. When the click event occurs outside of the `closeRef` element, the
    `setIsPreview` function is called with the argument `false`, which sets the `isPreview` state to
    `false`. */
    useOnClickOutside(closeRef,()=>{
        setIsPreview(false)
    })
      
      
    return (
        <div data-te-modal-init className={`fixed left-0 top-0 z-[1055] bg-[#00000047]  ${true ? '' : 'hidden'} h-full w-full overflow-y-auto overflow-x-hidden outline-none `} id="descriptionModal" tabindex="-1" aria-labelledby="descriptionModal" aria-modal="true" role="dialog">
            <div data-te-modal-dialog-ref className="pointer-events-none relative flex min-h-[calc(100%-1rem)] items-center opacity-1 transition-all duration-300 ease-in-out min-w-[850px] mx-auto max-w-[850px]">
                <div ref={closeRef} className="pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none dark:bg-neutral-600 min-w-[850px] mx-auto max-w-[850px]"
                    style={{'margin-top':'10px', 'height':'calc(100vh - 17px)'}}
                >
                    <div className="heading-section">
                        <div className='flex flex-shrink-0 items-center rounded-t-md bg-blue-50 py-2 px-3 justify-between'>
                            <h1 className="main_heading">
                                {`Payslip for the month of ${tableData.month}`}
                            </h1>
                            <div className='flex items-center'>
                                <button
                                    onClick={() => { setIsPreview(false) }}
                                    id='close'
                                    className='cancl-btn'
                                >Close</button>
                                <button
                                    id='download'
                                    onClick={() => handleDownload()}
                                    className='actn-btn'
                                    style={{ 
                                        ...(loadingDownload && {
                                            width: '120px',
                                            cursor: 'default' 
                                        })
                                    }}
                                >{loadingDownload ? <Loader /> : "Download"}</button>
                            </div>
                        </div>

                        <div className='paySlipPrvw scroll-bar  py-3 px-[30px]'>

                            <h5 className="school_heading">
                                {branch_data.branch_name}
                            </h5>
                            <p className="school_address">
                                {branch_data?.address_line_1}, {branch_data?.address_line_2} <br></br>
                                {branch_data?.city}, {branch_data?.state} - {branch_data?.pincode}
                            </p>

                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    paddingTop: 17,
                                    paddingBottom: 5,
                                    borderBottom: "1px solid #E6E8EA"
                                }}
                            >
                                <div style={{ width: "60%" }}>
                                    <div className="details_section">
                                        <p className="details_heading">
                                            Employee Number
                                        </p>
                                        <p className="details_content">
                                            {tableData?.employee_id}
                                        </p>
                                    </div>
                                    <div className="details_section">
                                        <p className="details_heading">
                                            Employee Name
                                        </p>
                                        <p className="details_content">{tableData?.employee_name}</p>
                                    </div>
                                    <div className="details_section">
                                        <p className="details_heading">Type</p>
                                        <p className="details_content">Teaching</p>
                                    </div>
                                    <div className="details_section">
                                        <p className="details_heading">
                                            Pay Period
                                        </p>
                                        <p className="details_content">{tableData?.month}</p>
                                    </div>
                                    <div className="details_section last">
                                        <p className="details_heading">Pay Type</p>
                                        <p className="details_content">Monthly</p>
                                    </div>
                                </div>
                                <div style={{ width: "40%", paddingLeft: 40 }}>
                                    <div
                                        style={{
                                            border: "1px solid #D0D5DD",
                                            width: "max-content",
                                            padding: "20px 18px"
                                        }}
                                    >
                                        <p
                                            className="details_heading"
                                            style={{
                                                width: "auto !important",
                                                textAlign: "center",
                                                paddingBottom: 8
                                            }}
                                        >
                                            Employee Net Pay
                                        </p>
                                        <p className="price">{formatIndianRupee(tableData?.net_pay)}</p>
                                    </div>
                                </div>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    paddingTop: 11,
                                    margin: "0 -6px"
                                }}
                            >
                                <div style={{ padding: "0 6px", width: "50%" }}>
                                    <div className="price_content_heading">
                                        <p>Earnings</p>
                                        <p>Amount</p>
                                    </div>
                                    <div style={{ height: 4 }} />
                                    <div className="price_content">
                                        <p>Basic</p>
                                        <p>{formatIndianRupee(tableData?.earnings_basic_mtd)}</p>
                                    </div>
                                    <div className="price_content">
                                        <p>House Rent Allowances</p>
                                        <p>{formatIndianRupee(tableData?.earnings_house_rent_allowances_mtd)}</p>
                                    </div>
                                    <div className="price_content">
                                        <p>Conveyance</p>
                                        <p>{formatIndianRupee(tableData?.earnings_conveyance_mtd)}</p>
                                    </div>
                                    <div className="price_content">
                                        <p>Medical Allowances</p>
                                        <p>{formatIndianRupee(tableData?.earnings_medical_allowances_mtd)}</p>
                                    </div>
                                    <div className="price_content">
                                        <p>Internet Reimbursement</p>
                                        <p>{formatIndianRupee(tableData?.earnings_internet_reimbusment_mtd)}</p>
                                    </div>
                                    <div className="price_content">
                                        <p>Miscellaneous</p>
                                        <p>{formatIndianRupee(tableData?.earnings_miscellaneous_mtd)}</p>
                                    </div>
                                    <div className="price_content">
                                        <p>Special Allowances</p>
                                        <p>{formatIndianRupee(tableData?.earnings_special_allowances_mtd)}</p>
                                    </div>
                                </div>
                                <div style={{ padding: "0 6px", width: "50%" }}>
                                    <div className="price_content_heading">
                                        <p>Deductions</p>
                                        <p>Amount</p>
                                    </div>
                                    <div style={{ height: 4 }} />
                                    <div className="price_content">
                                        <p>Provident Fund</p>
                                        <p>{formatIndianRupee(tableData?.deductions_provident_fund_mtd)}</p>
                                    </div>
                                    <div className="price_content">
                                        <p>Professional Tax</p>
                                        <p>{formatIndianRupee(tableData?.deductions_professional_tax_mtd)}</p>
                                    </div>
                                    <div className="price_content">
                                        <p>TDS</p>
                                        <p>{formatIndianRupee(tableData?.deductions_tds_mtd)}</p>
                                    </div>
                                    <div className="price_content">
                                        <p>ESI</p>
                                        <p>{formatIndianRupee(tableData?.deductions_esi_mtd)}</p>
                                    </div>
                                    <div className="price_content">
                                        <p>Other</p>
                                        <p>{formatIndianRupee(tableData?.deductions_other_mtd)}</p>
                                    </div>
                                </div>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    paddingTop: 11,
                                    margin: "0 -6px"
                                }}
                            >
                                <div style={{ padding: "0 6px", width: "50%" }}>
                                    <div className="price_content">
                                        <p class="font-semibold">
                                            Gross Earnings
                                        </p>
                                        <p>{formatIndianRupee(tableData?.total_earnings)}</p>
                                    </div>
                                </div>
                                <div style={{ padding: "0 6px", width: "50%" }}>
                                    <div className="price_content">
                                        <p class="font-semibold">
                                            Tax Deduction
                                        </p>
                                        <p>{formatIndianRupee(tableData?.total_deductions)}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="total_price">
                                <p>
                                    <span className='font-semibold'>
                                        Total Net Payable {formatIndianRupee(tableData?.net_pay)}
                                    </span>
                                    <span className=''>
                                        {' (' + tableData?.net_pay_words + ')'}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
